var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.7567 0 7.68683 1.68499 4.68651 4.68651C1.68482 7.68649 0 11.7564 0 16C0 20.2436 1.68499 24.3132 4.68651 27.3135C7.68649 30.3152 11.7564 32 16 32C20.2436 32 24.3132 30.315 27.3135 27.3135C30.3152 24.3135 32 20.2436 32 16C32 11.7564 30.315 7.68683 27.3135 4.68651C24.3135 1.68482 20.2436 0 16 0ZM24.5585 9.92171L15.6702 22.3667C15.3652 22.7917 14.8902 23.0617 14.3685 23.1051C14.3202 23.1101 14.2702 23.1117 14.2218 23.1117C13.7502 23.1117 13.2985 22.9234 12.9652 22.59L7.63185 17.2567C6.9485 16.5617 6.95354 15.445 7.64352 14.755C8.33352 14.065 9.45019 14.06 10.1452 14.7434L13.9952 18.5917L21.6637 7.85676C22.2353 7.05676 23.3453 6.87176 24.1437 7.44176C24.9437 8.01174 25.1285 9.12337 24.5585 9.92171Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/SuccessMark.eae716143f6524984f1d3b132c3dad75.svg";
export { ForwardRef as ReactComponent };